import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Import utlis
import LoadableMng from 'components/utilities/lodable_manager/LodableMng';

// Import components
import ProtectedDashboard from 'components/hoc/ProtectedDashboard';
import ProtectedUserLogged from 'components/hoc/ProtectedUserLogged';

// Import paths
import { MAIN_PATHS } from './paths';

const Main = LoadableMng({
	func: () => import('components/views/Main')
});

const NotFound = LoadableMng({
	func: () => import('components/views/NotFound')
});

const Static = LoadableMng({
	func: () => import('components/templates/StaticContentTemplate')
});

const MultioperatorLogin = LoadableMng({
	func: () =>
		import(
			'components/views/authentication/login_multioperators/MultioperatorLogin'
		),
	delay: 800
});

const { HOME } = MAIN_PATHS;

function OperatorRoutes() {
	const { signOutLoading } = useSelector(({ auth }) => auth);

	return (
		<Switch>
			{signOutLoading && <Redirect to="/logowanie" />}
			<Redirect exact from={HOME} to="/logowanie" />
			<Route path="/strona/:alias" component={Static} />
			<ProtectedUserLogged path="/logowanie" component={MultioperatorLogin} />
			<Route path="/404" component={NotFound} />
			<ProtectedDashboard component={Main} />
			<Redirect to="/logowanie" />
		</Switch>
	);
}

export default OperatorRoutes;
